import React from 'react';
import { ExampleButtons } from 'styleguide/components/buttons';
import { ExampleType } from 'styleguide/components/typography';
import { ExampleColors } from 'styleguide/components/colors';
import { ExampleAvatars } from 'styleguide/components/avatars';
import { ExampleTags } from 'styleguide/components/tags';
import { ExampleForms } from 'styleguide/components/forms';
import { ExampleThumbnails } from 'styleguide/components/thumbnails';
import { ExampleNavigation } from 'styleguide/components/navigation';
import { ExampleTables } from 'styleguide/components/tables';
import { ExampleComments } from 'styleguide/components/comments';
import { ExampleCallouts } from 'styleguide/components/callouts';

const StyleGuide = () =>
  <div className="styleguide">
    <div className="container">
      <div className="row">
        <div className="medium-4 medium-push-12 columns">
          <nav className="leftnav">
            <ul>
              <li><a href="#type">Typography</a></li>
              <li><a href="#colors">Colors</a></li>
              <li><a href="#buttons">Buttons</a></li>
              <li><a href="#tags">Tags, Labels, &amp; Badges</a></li>
              <li><a href="#avatars">Avatars</a></li>
              <li><a href="#thumbnails">Thumbnails</a></li>
              <li><a href="#havigation">Navigation</a></li>
              <li><a href="#forms">Forms & Inputs</a></li>
              <li><a href="#tables">Tables</a></li>
              <li><a href="#comments">Comments</a></li>
              <li><a href="#callouts">Callouts</a></li>
            </ul>
          </nav>
        </div>
        <div className="medium-12 columns">
          <h1>cS3 Style Guide</h1>
          <ExampleType />
          <ExampleColors />
          <ExampleButtons />
          <ExampleTags />
          <ExampleAvatars />
          <ExampleThumbnails />
          <ExampleNavigation />
          <ExampleForms />
          <ExampleTables />
          <ExampleComments />
          <ExampleCallouts />
        </div>
      </div>
    </div>
    <link
      href="https://maxcdn.bootstrapcdn.com/font-awesome/4.6.3/css/font-awesome.min.css"
      rel="stylesheet"
      integrity="sha384-T8Gy5hrqNKT+hzMclPo118YTQO6cYprQmhrYwIiQ/3axmI1hQomh7Ud2hPOy8SP1"
      crossOrigin="anonymous"
    />
  </div>;


export default StyleGuide;



// WEBPACK FOOTER //
// ./styleguide/components/index.jsx